import React from 'react';
import { Text } from 'components/text/Text';
import { RichText } from 'components/rich-text/RichText';

export const TextSlice = ({
  tagline,
  title,
  heading,
  text,
  columns,
  color,
  image,
  link,
  label,
  isSlice,
  isSplitPage,
  isArticle,
  isEvent,
  isProduct,
}) => {
  return (
    <Text
      tagline={tagline}
      title={RichText.render(heading)}
      colCount={columns}
      text={RichText.render(text)}
      color={color}
      image={image}
      link={link}
      label={label}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
      isArticle={isArticle}
      isEvent={isEvent}
      isProduct={isProduct}
    />
  );
};

export default TextSlice;
